import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/AdminSettingCustom';

const getSettingCustomColorReducer = handleActions({
    [Actions.getSettingCustomColorRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getSettingCustomColorReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getSettingCustomColorReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.getSettingCustomColorClear]: () => ({
        data: {},
        isFetching: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateSettingCustomColorReducer = handleActions({
    [Actions.updateSettingCustomColorRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.updateSettingCustomColorReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.updateSettingCustomColorReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.updateSettingCustomColorClear]: () => ({
        data: {},
        isFetching: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const getSettingCustomTextReducer = handleActions({
    [Actions.getSettingCustomTextRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getSettingCustomTextReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getSettingCustomTextReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.getSettingCustomTextClear]: () => ({
        data: {},
        isFetching: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateSettingCustomTextReducer = handleActions({
    [Actions.updateSettingCustomTextRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.updateSettingCustomTextReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.updateSettingCustomTextReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.updateSettingCustomTextClear]: () => ({
        data: {},
        isFetching: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const getSettingCustomCommentReducer = handleActions({
    [Actions.getSettingCustomCommentRequest]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getSettingCustomCommentReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getSettingCustomCommentReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.getSettingCustomCommentClear]: () => ({
        data: {},
        isFetching: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateSettingCustomCommentReducer = handleActions({
    [Actions.updateSettingCustomCommentRequest]: (state) => ({
        ...state,
        isFetching: true,
        updateStatus: false,
    }),
    [Actions.updateSettingCustomCommentReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        updateStatus: true,
    }),
    [Actions.updateSettingCustomCommentReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        updateStatus: false,
    }),
    [Actions.updateSettingCustomCommentClear]: () => ({
        data: {},
        isFetching: false,
        errors: {},
        updateStatus: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    updateStatus: false,
});

const getSettingCustomTimerctrlReducer = handleActions({
    [Actions.getSettingCustomTimerctrlRequest]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getSettingCustomTimerctrlReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getSettingCustomTimerctrlReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.getSettingCustomTimerctrlClear]: () => ({
        data: {},
        isFetching: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateSettingCustomTimerctrlReducer = handleActions({
    [Actions.updateSettingCustomTimerctrlRequest]: (state) => ({
        ...state,
        isFetching: true,
        updateStatus: false,
    }),
    [Actions.updateSettingCustomTimerctrlReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        updateStatus: true,
    }),
    [Actions.updateSettingCustomTimerctrlReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        updateStatus: false,
    }),
    [Actions.updateSettingCustomTimerctrlClear]: () => ({
        data: {},
        isFetching: false,
        errors: {},
        updateStatus: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    updateStatus: false,
});



export default combineReducers({
    getCustomColor: getSettingCustomColorReducer,
    updateCustomColor: updateSettingCustomColorReducer,
    getCustomText: getSettingCustomTextReducer,
    updateCustomText: updateSettingCustomTextReducer,
    getCustomComment: getSettingCustomCommentReducer,
    updateCustomComment: updateSettingCustomCommentReducer,

    getCustomTimerctrl: getSettingCustomTimerctrlReducer,
    updateCustomTimerctrl: updateSettingCustomTimerctrlReducer,
   
});
